<section class="login-screen">
  <div class="background container-fluid">
    <!-- <div class="logo">
      <a href="javascript:;" routerLink="/"><img src="assets/img/logo.svg"></a>
    </div> -->
    <div class="container main-heading-maintain">
      <img src="assets/img/maintain.png" alt="">
      <!-- <h1>Welcome to Crafttor! <span aria-label="tada" role="img">🎉</span></h1> -->
      <p style="font-size: 16px;"><b>Our website is going through a version upgrade and will be available soon.
        <br>We request you to visit after sometime.</b></p>
      <p><b>Thank you! for visiting.</b></p>
    </div>
  </div>
</section>

<section>
  <div class="footer-heading">
    <div class="container">
      <div class="row">
        <div class="col-md-3 row-col">
        </div>
        <div class="col-md-6 row-col copyright text-center">
          copyright © 2025 Crafttor. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</section>
